var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.title}},[_c('trading-vue',{ref:"chart",attrs:{"id":_vm.title,"type":"candles","width":_vm.width,"color-back":"#ffffff","color-grid":"#eee","color-text":"#333","timezone":0,"titleTxt":_vm.title,"data":_vm.chart_data,"toolbar":false,"chart-config":{
            DEFAULT_LEN: 1200,
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }